module.exports = __webpack_public_path__ + "static/oracle_gold_partner-02eefabec141fad2bc31b89b7a8ef8b1.png";